import localStorage from './localStorageUtils';
import sessionStorage from './sessionStorageUtils';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
export const loadStateIfNeeded = () => {
  if (/\/kmsi\b/i.test(window.location.pathname) && (/code=/i.test(window.location.search) || /returnUrl=/i.test(window.location.search)))
    return loadState();
};

export const loadState = () => {
  return loadStateFromHistory('state', 'local');
};


export const saveState = (state) => {
  saveStateToHistory('state', state, 'local');
};

export const saveStateToHistory = (key = 'state', state, location = 'session') => {
  key = normalizeKey(key);
  location == 'session' ? sessionStorage.setItem(`state::${key}`, state, true) : localStorage.setItem(`state::${key}`, state, true);
};

export const loadStateFromHistory = (key = 'state', location = 'session') => {
  key = normalizeKey(key);
  return location == 'session' ? sessionStorage.getItem(`state::${key}`, true) : localStorage.getItem(`state::${key}`, true);
};

export const removeStateFromHistory = (key = 'state', location = 'session') => {
  key = normalizeKey(key);
  location == 'session' ? sessionStorage.removeItem(`state::${key}`) : localStorage.removeItem(`state::${key}`);
};

const normalizeKey = (key) => {
  var  newkey =key?.replace(/(^#+)|(\/\s*$)/g, '').toLowerCase();
  if(isNullOrEmpty(newkey)) {
    newkey="";
  }
  return newkey;
};

const clearStorage = (storage) => {
  const itemsToRemove = [];
  for (let i = 0; i < storage.length; ++i) {
    const key = storage.key(i);
    if (key.startsWith('state::')) itemsToRemove.push(key);
  }
  itemsToRemove.forEach((item) => storage.removeItem(item));
};

export const clearStateHistory = (location = 'session') => {
  clearStorage(location == 'session' ? sessionStorage : localStorage);
};

const HISTORY_STACK_PREFIX = 'stateHistoryStack::';
export const pushHistoryKey = (action, location = 'session') => {
  const type = action.type;
  const context = type.split('/')[0];
  const storageKey = `${HISTORY_STACK_PREFIX}${context}`;
  const storage = location === 'session' ? sessionStorage : localStorage;
  const stack = storage.getItem(storageKey, false) || [];
  const normalized = normalizeKey(action.payload);
  if(isNullOrEmpty(normalized) && stack.length > 1) {
    return;
  }
  if (stack.length === 0 || stack[stack.length - 1] !== normalized) {
    stack.push(normalized);
    storage.setItem(storageKey, stack, false);
  }
};


export const getPreviousHistoryKeyAndPop = (action, location = 'session',stepToSkipe=[]) => {
  const type = action.type;
  const context = type.split('/')[0];
  const storageKey = `${HISTORY_STACK_PREFIX}${context}`;
  const storage = location === 'session' ? sessionStorage : localStorage;
  const stack = storage.getItem(storageKey, false) || [];
  if (stack.length <= 1) return null;
  if(stepToSkipe.includes(stack[stack.length - 2])) {
    stack.pop();
    storage.setItem(storageKey, stack, false);
    getPreviousHistoryKeyAndPop(action, location, stepToSkipe);
  }
  stack.pop();
  storage.setItem(storageKey, stack, false);
  var separator = isNullOrEmpty(stack[stack.length - 1]) ? '' :'#';
  var PreviousKeyInStorage = window.location.pathname + '::' + separator + stack[stack.length - 1];
  return PreviousKeyInStorage;
};



export const clearHistoryKeyStack = (type, location = 'session') => {
  const context = type.split('/')[0];
  const storageKey = `${HISTORY_STACK_PREFIX}${context}`;
  const storage = location === 'session' ? sessionStorage : localStorage;
  storage.removeItem(storageKey);
};
